// Shared visual language for the Batch Assessment workspace.
// Centralizes proficiency/status color coding so BatchStudentList,
// BatchStudentDetail, BatchDOKSection, BatchEntryPanel and
// BatchAssessmentSummary all read the same way.

export const BRAND_GREEN = "#738B3B";
export const BRAND_GREEN_DARK = "#647A33";
export const BRAND_GREEN_LIGHT = "#9AAC70";

// Overall assessment / DOK proficiency levels.
export const PROFICIENCY_COLORS = {
    Emerging: {
        text: "#B3261E",
        bg: "#FBE9E7",
        border: "#E4A79E",
    },
    Developing: {
        text: "#8A6D00",
        bg: "#FFF6DA",
        border: "#E8CE78",
    },
    Proficient: {
        text: "#2E6B2E",
        bg: "#E8F3E1",
        border: "#A9C98C",
    },
    Extending: {
        text: "#1E4F91",
        bg: "#E8F0FB",
        border: "#A9C3E8",
    },
};

// Non-proficiency statuses used on student rows / assessment status.
export const NEUTRAL_STATUS_COLORS = {
    not_assessed: {
        text: "#6B6F5E",
        bg: "#EFEFE8",
        border: "#D3D5C8",
    },
    incomplete: {
        text: "#9A6A00",
        bg: "#FFF3DC",
        border: "#EFCE86",
    },
    unsaved: {
        text: "#1E4F91",
        bg: "#E8F0FB",
        border: "#A9C3E8",
    },
};

export const getProficiencyColors = (value) =>
    PROFICIENCY_COLORS[value] || null;

// Ready-to-spread sx for a MUI Chip, colored by proficiency value.
export const getProficiencyChipSx = (value) => {
    const palette = getProficiencyColors(value);

    if (!palette) {
        return {};
    }

    return {
        color: palette.text,
        backgroundColor: palette.bg,
        border: "1px solid",
        borderColor: palette.border,
        fontWeight: 700,
    };
};

// Ready-to-spread sx for a MUI Select's root, tinted by proficiency value.
export const getProficiencySelectSx = (value) => {
    const palette = getProficiencyColors(value);

    if (!palette) {
        return {
            backgroundColor: "white",
        };
    }

    return {
        backgroundColor: palette.bg,
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: palette.border,
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: palette.border,
        },
    };
};

// Brand-colored checkbox state, used across all skill/bulk checkboxes.
export const BRAND_CHECKBOX_SX = {
    color: BRAND_GREEN_LIGHT,
    "&.Mui-checked": {
        color: BRAND_GREEN,
    },
};

// Pill-shaped inputs, matching the Assess Single Student page.
export const PILL_FIELD_SX = {
    "& .MuiOutlinedInput-root": {
        borderRadius: 999,
    },
};
